type SetEmptySelectValue = (value?: number[]) => number[] | string;

export const setEmptySelectValue: SetEmptySelectValue = (value) =>
  !value || value.length === 0 ? '' : value;
